import React, { useEffect, useMemo, useRef, useState } from "react";
// import { useTable, usePagination, useSortBy, useRowSelect, useFilters, useBlockLayout, useResizeColumns } from "react-table";
import { useReactTable, getCoreRowModel, getPaginationRowModel, getSortedRowModel, flexRender } from "@tanstack/react-table";
import DataTablePaging from "components/DataTable/DataTablePaging";
import "react-datepicker/dist/react-datepicker.css";
import "react-calendar/dist/Calendar.css";
import { v4 as uuidv4 } from "uuid";
import BasicButton from "components/button/BasicButton";

// ReactDataTable. 단순 Display만. 각종 처리는 부모에서 처리.
const ReactDataTableDisplay = (props) => {
	const {
		columns, //컬럼
		customDatas, //부모에서 주는 데이터 -> inisitalDatas 변수명변경
		returnSelectRows, //부모로 선택한 row 배열 리턴
		hideCheckBox, //체크박스 상태 플래그
		// realTime,	// 실시간 데이터 전달 여부
		isSingleSelect, //단일 체크박스 선택 여부
		isPageNation,	// 페이징 여부
		defaultPageSize, // 기본 페이징 사이즈
		isSpecialRow,	// 페이지 마지막 줄에 배경색
		isLastSpecialRow,	// 데이터 마지막 줄에 배경색
		rowClick,	// row(tr) 클릭 시 이벤트
		specialRow,	// 배경색 다르게 할 row의 key/value/class. key의 value가 일치하는 row의 class 처리.
		evenRowClass,	// 짝수열 tr에 적용할 class
		oddRowClass,	// 홀수열 tr에 적용할 class
		applyTrHover = true,	// boolean. tr에 hover시에 class 적용 여부
		rowDraggable,	// 행 Drag가능 여부
		onRowDragDrop,		// 행 Drag&Drop 시 실행 Function
		pagingInfo,		// 데이터를 미리 paging 해서 넘기는 방식에서의 페이징 정보
		noThead=false,
		tableWidth="100%",	// 전체 테이블 width. percentageWidth가 true일때만 처리. 기본은 columnWidth의 합계.
		percentageWidth = false,	// Column width를 percentage로 설정할지 여부
		maxHeight,	// 데이터 영역 maxHeight

	} = props;

	const [tableData, setTableData] = useState([]);
	const [isLoading, setIsLoading] = useState(true); //로딩화면(true 일때 로딩화면)
	const chkAll = useRef(null);	// 전체선택 체크박스
	// const rowspan = useRef({});

	useEffect(() => {
		if(customDatas) {
		 setTableData(JSON.parse(JSON.stringify(customDatas))); //수정 데이터
		}
		setIsLoading(false);
	}, [customDatas]);

	// useEffect(() => {
	//	realTime && realTime(tableData);
	// }, [tableData]);


	/*
	const columnsConfig = useMemo(() => 
		columns.map(column => ({
		 accessorKey: column.col,
		 header: column.header,
		}))
	, [columns]);
*/
	const columnsConfig = useMemo(
		//컬럼 초기 상태
		() =>
		columns.map((column) => ({
			accessorKey: column.col,
			header: column.header,
			// sortable: true,
			sortable: false,
			width: column.notView ? 0 : column.cellWidth,
			type: column.type,
			options: column.options,
			notView: column.notView,
			disabled: column.disabled,
			require: column.require,
			textAlign: column.textAlign,
			onClick: column.onClick,
			onMouseOver: column.onMouseOver,
			color: column.color,
			label: column.label,
			// rowspan: column.rowspan,
		 })),
		[columns]
	);

	const table = useReactTable({
		columns: columnsConfig,
		data: tableData,
		getCoreRowModel: getCoreRowModel(),
	});

	const getCheckAll = () => {
		const rows = table.getPaginationRowModel().rows;

		return (
			<input
				id={uuidv4()}
				ref={chkAll}
				type="checkbox"
				// {...table.getToggleAllPageRowsSelectedProps()}
				// {...table.getToggleAllPageRowsSelectedHandler()}
				className="table-checkbox"
				checked={table.getIsAllPageRowsSelected()}
				indeterminate={table.getIsSomePageRowsSelected().toString()}
				onChange={table.getToggleAllPageRowsSelectedHandler()}
				style={{visibility: isSingleSelect ? "hidden" : "visible"}}
				// indeterminate="false"
				// checked={rows.filter(r => !r.original.isDisabled).length > 0 && rows.filter(r => !r.original.isDisabled).length === rows.filter(r => !r.original.isDisabled && r.isSelected).length}
				// checked={rows.filter(r => !r.original.isDisabled).length > 0 && rows.filter(r => !r.original.isDisabled).length === rows.filter(r => !r.original.isDisabled && r.getIsSelected()).length}
			/>
		)
	};
	const getCheckRow = (row) => {
		const rows = table.getPaginationRowModel().rows;
		return (
			<input
				id={uuidv4()}
				type="checkbox"
				className="table-checkbox"
				indeterminate="false"
				// onClick={(e) => checkBoxClick(e, row, rows)}
				onChange={(e) => checkBoxClick(e, row, rows)}
				disabled={row.original.isDisabled}
				checked={row.getIsSelected()}
			/>
		)
	}
/*
	const {
		// getTableProps,
		getHeaderGroups,
		getTableBodyProps,
		// headerGroups,
		prepareRow,
		page,
		// state: { pageIndex, pageSize },
		pageIndex, pageSize,
		previousPage,
		nextPage,
		canPreviousPage,
		canNextPage,
		pageOptions,
		gotoPage,
		setPageSize,
		pageCount,
		selectedFlatRows, // 선택된 행 데이터
		toggleAllRowsSelected, // 전체선택 on off
		toggleRowSelected,
	} = useReactTable(
		{
		 columns: columnsConfig,
		 data: tableData,
		 getCoreRowModel: getCoreRowModel(),
		 getPaginationRowModel: getPaginationRowModel(),
		 getSortedRowModel: getSortedRowModel(),
		 initialState: { pageIndex: 0, pageSize: isPageNation ? defaultPageSize || 10 : (tableData && tableData.length) || 200 }, // 초기값
		},
		// useFilters,
		// useSortBy,
		// usePagination,
		// useRowSelect,
		// useBlockLayout,
		// useResizeColumns,
		(hooks) => {
		 hooks.visibleColumns.push((columns) => [
			...(hideCheckBox !== undefined && hideCheckBox
				? []
				: [
					{
					 id: "selection",
					 // Header: ({ getToggleAllPageRowsSelectedProps, rows }) => {
					 Header: ({ getToggleAllPageRowsSelectedProps, rows }) => {
						return (
						<>
							{isSingleSelect ? (
								""
							) : (
								// <div>
								 <input
									id={uuidv4()}
									ref={chkAll}
									type="checkbox"
									{...getToggleAllPageRowsSelectedProps()}
									className="table-checkbox"
									indeterminate="false"
									checked={rows.filter(r => !r.original.isDisabled).length > 0 && rows.filter(r => !r.original.isDisabled).length === rows.filter(r => !r.original.isDisabled && r.isSelected).length}
									// onChange={(e) => {
									//	if(!e.target.checked) {
									//		toggleAllRowsSelected(false, false);
									//	} else {
									//		rows.filter(row => !row.original.isDisabled).forEach(row => {
									//			toggleRowSelected(row.id, true);
									//		});
									//	}
									// }}
								 />
								// </div>
							)}
							</>
					 )
					},
					 Cell: ({ row, rows }) => {
						return (
						// <div>
							<input
								id={uuidv4()}
								type="checkbox"
								{...row.getToggleRowSelectedProps()}
								className="table-checkbox"
								indeterminate="false"
								onClick={(e) => checkBoxClick(e, row, rows)}
								disabled={row.original.isDisabled}
							/>
						// </div>
					 )},
					 // Cell: ({ row }) => (
					 //	<div>
					 //		<input
					 //			id={uuidv4()}
					 //			type="checkbox"
					 //			{...row.getToggleRowSelectedProps()}
					 //			className="table-checkbox"
					 //			indeterminate="false"
					 //			onClick={(e) => checkBoxClick(e, row)}
					 //		/>
					 //	</div>
					 // ),
					 width: 35,
					},
				]),
			...columns,
		 ]);
		}
	);
	*/

	// 테이블 체크박스 클릭 시
	const checkBoxClick = (e, row, rows) => {
		e && e.stopPropagation();

		// const id = row.id;
		if (isSingleSelect) {
			// 단일 선택 시
			table.toggleAllRowsSelected(false, false);
			row.toggleSelected();
		} else {
			row.toggleSelected();
			// 단일 선택 아닐때
			// 전체 선택 여부에 따라 전체 선택 체크박스 처리
			// if(rows.filter(r => !r.original.isDisabled).length === rows.filter(r => !r.original.isDisabled && (r.id === row.id ? !r.isSelected : r.isSelected)).length) {
			// 	// 비활성화 되지 않은 row 전체 선택 됨.
			// 	chkAll.current.checked = true;
			// } else {
			// 	chkAll.current.checked = false;
			// }
		}
	};

	// 테이블 체크박스 선택 변경시
	// useEffect(() => {
	// 	const selects = table.selectedFlatRows && table.selectedFlatRows.map((row) => row.values);
	// 	returnSelectRows && returnSelectRows(selects); //부모로 모든 선택 데이터 리턴
	// }, [table.selectedFlatRows]);
	// 테이블 체크박스 선택 변경시
	useEffect(() => {
		const selectedRows = table.getSelectedRowModel().rows;
		const selects = selectedRows && selectedRows.map((row) => row.original);

		returnSelectRows && returnSelectRows(selects); //부모로 모든 선택 데이터 리턴
	}, [table.getSelectedRowModel().rows]);

	// 테이블 row (tr) 클릭 시
	const onTrClick = (row) => {
		if(rowClick) {
			if((typeof rowClick).toLowerCase() === "function") {
				rowClick(row.original);
		 	} else if(rowClick === "checkbox" && !hideCheckBox) {
				// row 클릭 시 체크박스 선택
				// table.toggleRowSelected(row.id, !row.isSelected);
				// toggleRowSelected(row.id, !row.isSelected);
				checkBoxClick(null, row, table.getPaginationRowModel().rows);
			}
		}

		/* 화면에 따라서 불편할지도...
		if(!rowClick && !hideCheckBox) {
		 // rowClick 이벤트가 없고, 체크박스 표시 이면
		 // row 클릭 시 체크박스 선택
		 toggleRowSelected(row.id, !row.isSelected);
		 checkBoxClick(null, row, page);
		}
		*/
		
	}

	const textAlignStyle = (column) => {
		switch (column.textAlign) {
		 case "left":
			return "txt-left";
		 case "right":
			return "txt-right";
		 default:
			return "txt-center";
		}
	};

	let colIdx = null;
	// 드래그
	const handleDragStart = (e, columnIndex) => {
		colIdx = columnIndex;	// 시작 Obj의 index 저장.
	};
	// 드롭
	const handleDrop = (e, columnIndex) => {
		if(colIdx === null) return;
		const tmp = tableData.slice(0, tableData.length);	// 원본 복사 (deep)
		const dragObj = tmp[colIdx];
		tmp.splice(colIdx, 1);	// 이동중인 Obj 꺼내고
		// tmp.splice(columnIndex, 0, dragObj);	// 현재 위치에 꺼낸 Obj 넣어주고 ->이렇게 하면 Drag와 Drop 개체의 원래 순서에 따라 무조건 위 또는 아래로 들어감..
		let targetIndex = columnIndex;

		if(colIdx < columnIndex) {
		 targetIndex -= 1;	// 위에서 뺀거면 실제 index가 하나 당겨지니까 1 빼줌.
		}

		if(e.target.offsetHeight / 2 < e.nativeEvent.offsetY) {
		 // drop 한 곳의 높이 중앙을 기준으로 아래쪽에 drop 한거면 아래쪽에 넣어줌.
		 targetIndex += 1;
		}
		tmp.splice(targetIndex, 0, dragObj);
		setTableData(tmp);

		onRowDragDrop && onRowDragDrop(tmp);	// 부모로 객체 전달
	}

	return (
		<>
		 {isLoading ? (
			// 로딩 화면을 보여줄 JSX
			<div className="Loading">
				<div className="spinner"></div>
				<div> Loading... </div>
			</div>
		 ) : (
			<div className={"data-table " + (applyTrHover ? " applyTrHover" : "")}>
				<div className={isPageNation ? "x-scroll" : "table-scroll"} style={maxHeight ? {maxHeight: maxHeight + "px"} : {}} >
					{/* <table {...getTableProps()} className="table-custom table-styled" style={{ tableLayout: "auto" }}> */}
					<table className="table-custom table-styled" style={{ tableLayout: "auto" }}>
					 {noThead ? null : (<thead>
						{/* {headerGroups.map((headerGroup, headerGroupIndex) => { */}
						{table.getHeaderGroups().map((headerGroup, idx) => {
							
							// const headerGroupProps = {...headerGroup.getHeaderGroupProps()};
							const headerGroupProps = {style: {display: "flex"}};
							if(percentageWidth) {
								headerGroupProps.style.width = tableWidth;
							}

							return (
							// <tr {...headerGroup.getHeaderGroupProps()}>
							<tr {...headerGroupProps} key={"header_tr_" + idx}>
								{!hideCheckBox && (<th>{getCheckAll()}</th>)}
								{headerGroup.headers.map((column, columnIndex) => {
								 if (column.column.columnDef.notView) {
									// notView가 true인 경우, 헤더 셀을 출력하지 않음
									return null;
								 }
								 // const headerProps = {...column.getHeaderProps()};
								 const headerProps = {style:{
									width: column.column.columnDef.width + "px",
									display: "inline-block",
									boxSizing: "border-box",
								 }};
								 if(percentageWidth) {
									if(column.id !== "selection") {	// 퍼센트로 width설정일때 (체크박스는 제외)
										headerProps.style.width = headerProps.style.width?.replace("px", "%");
									} else {
										// 체크 박스는 별도 (35px 맞추고, 가운데 정렬하기 위함.)
										headerProps.style.display = "flex";
										headerProps.style.padding = "0 8.5px";	// 전체너비-border-checkbox너비 / 2 = (35-(1*2)-16)/2 = 17/2 = 8.5
										headerProps.style.alignItems = "center";
										headerProps.style.justifyContent = "center";
									}
								 }

								 return (
									<th
										key={"header_th_" + columnIndex}
										// {...column.getHeaderProps(column.getSortByToggleProps())}
										// {...column.getHeaderProps()}
										{...headerProps}
										id={`header-${column.id}`}
										className={columnIndex === 0 ? "first-column" : ""}>
										{/* {column.render("Header")} */}
										{
											flexRender(
											 column.column.columnDef.header,
											 column.getContext()
											)
										}
										<span style={{ color: "red", margin: 0 }}>{column.require === true ? "*" : ""}</span>
									</th>
								 );
								})}
							</tr>
						)})}
					 </thead>)}
					 {tableData.length > 0 ? (
						// <tbody {...getTableBodyProps()}>
						// <tbody {...table.getTableBodyProps()}>
						<tbody >
							{table.getPaginationRowModel().rows.map((row, rowIndex) => {
								// prepareRow(row);
								// const isPageLastRow = isSpecialRow && row.index === page.length - 1;
								const isPageLastRow = isSpecialRow && row.index === table.getPaginationRowModel().rows.length -1;
								const isLastRow = isLastSpecialRow && row.index === tableData.length - 1;
								const customSpecialRow = specialRow && String(specialRow.val) === String(row.original[specialRow.key]);
								// const rowsProps = {...row.getRowProps()};
								const rowsProps = {style:{display: "flex"}};
								if(percentageWidth) {
								 rowsProps.style.width = tableWidth;
								}

								return (
								 // <tr {...row.getRowProps()} className={isPageLastRow || isLastRow || customSpecialRow ? "special-row" : ""} onClick={() => onTrClick(row)} 
								 <tr {...rowsProps}
									key={"body_tr_" + rowIndex}
									className={
										(isPageLastRow || isLastRow ? "special-row" : "")
										+ (customSpecialRow ? (specialRow.class ?? "custom-special-row") : "")
										+ (evenRowClass && rowIndex % 2 === 1 ? " " + evenRowClass : "")
										+ (oddRowClass && rowIndex % 2 === 0 ? " " + oddRowClass : "")
										+ ((typeof rowClick).toLowerCase() === "function" ? " cursor-pointer" : "")
									}
									onClick={() => onTrClick(row)} 
									draggable={rowDraggable}
									onDragStart={e=> rowDraggable && handleDragStart(e, rowIndex)}
									onDragOver={e=>rowDraggable && e.preventDefault()} 
									onDrop={e=>rowDraggable && handleDrop(e, rowIndex)}
									// style={{background: "#ccf1ff30"}}
								 >
									{!hideCheckBox && (<td>{getCheckRow(row)}</td>)}

									{/* {row.cells.map((cell, cellIndex) => { */}
									{row.getAllCells().map((cell, cellIndex) => {
										if (cell.column.columnDef.notView) {
											// notView가 true인 경우, 셀을 출력하지 않음
											return null;
										}

										// rowspan 처리
										// if(typeof cell.column.columnDef.rowspan === "function") {
										// 	if(rowspan.current[cell.column.columnDef.accessorKey] == null || rowspan.current[cell.column.columnDef.accessorKey] <= 1) {
										// 		rowspan.current[cell.column.columnDef.accessorKey] = cell.column.columnDef.rowspan(row.original);
										// 	} else {
										// 		rowspan.current = rowspan.current - 1;
										// 	}
										// }

										// const cellProps = {...cell.getCellProps()};
										const cellProps = {style:{
											width: cell.column.columnDef.width + "px",
											display: "inline-block",
											boxSizing: "border-box",
										}};
										if(percentageWidth) {
											if(cell.column.id !== "selection") {	// 퍼센트로 width설정일때 (체크박스는 제외)
											 cellProps.style.width = cellProps.style.width?.replace("px", "%");
											} else {
											 // 체크 박스는 별도 (35px 맞추고, 가운데 정렬하기 위함.)
											 cellProps.style.display = "flex";
											 cellProps.style.padding = "0 8.5px";	// 전체너비-border-checkbox너비 / 2 = (35-(1*2)-16)/2 = 17/2 = 8.5
											 cellProps.style.alignItems = "center";
											 cellProps.style.justifyContent = "center";
											}
										}

										return (
											// <td {...cell.getCellProps()} className={textAlignStyle(cell.column)} id="otherCol">
											<td {...cellProps} className={textAlignStyle(cell.column)} id="otherCol"
											 key={"body_td_" + rowIndex + "-" + cellIndex}>
											 {cell.column.columnDef.type === "input" ? (
												<input
													key	= {cell.column.id + row.index}
													type = "text"
													value = {""}
													name = {cell.column.id}
													onClick={(e) => {
														if(cell.column.columnDef.onClick) {
														 e.preventDefault();
														 e.stopPropagation();
														 cell.column.columnDef.onClick(row.original);
														}
													}}
												/>
											 ) : cell.column.columnDef.type === "modButton" && cell.getValue() ? (
												<BasicButton
													label={cell.column.columnDef.label ?? "수정"}
													disabled={false}
													className="list-button btn-mod"
													onClick={(e) => {
														if(cell.column.columnDef.onClick) {
														 e.preventDefault();
														 e.stopPropagation();
														 cell.column.columnDef.onClick(row.original);
														}
													}}
												/>
											 ) : cell.column.columnDef.type === "delButton" ? (
												<BasicButton
													label={cell.column.label ?? "삭제"}
													disabled={false}
													className="list-button btn-del"
													onClick={(e) => {
														if(cell.column.columnDef.onClick) {
														 e.preventDefault();
														 e.stopPropagation();
														 cell.column.columnDef.onClick(row.original);
														}
													}}
												/>
											 ) : cell.column.columnDef.type === "copyButton" ? (
												<BasicButton
													label={"복사"}
													onClick={(e) => {
														if(cell.column.columnDef.onClick) {
														 e.preventDefault();
														 e.stopPropagation();
														 cell.column.columnDef.onClick(row.original);
														}
													}}
													className="btn-copy list-button"
												/>
											 ) : cell.column.columnDef.type === "image" ? (
												<img src={cell.getValue()} style={{maxWidth: "100%", maxHeight: "100px"}} />
											 ) : (
												<span
													onClick={(e) => {
														if(cell.column.columnDef.onClick) {
														 e.preventDefault();
														 e.stopPropagation();
														 cell.column.columnDef.onClick(row.original);
														}
													}}
													onMouseOver={(e) => {
														if(cell.column.columnDef.onMouseOver) {
														 e.preventDefault();
														 e.stopPropagation();
														 cell.column.columnDef.onMouseOver(row.original, e);
														}
													}}
													// style={cell.column.onClick? {cursor: "pointer"}: {}}>
													style={{
														...(cell.column.columnDef.onClick ? {cursor: "pointer"}: {}),
														...(typeof cell.column.columnDef.color === "function" ? {color: cell.column.columnDef.color(row.original)} : {}),
														...(typeof cell.column.columnDef.color !== "function" ? {color: cell.column.columnDef.color} : {}),
													}}>
													{cell.column.Header === "연월" && cell.value ? (
														cell.value.substring(0, 7)
													// ) : typeof cell.getValue() === "number" ? (
													// 	cell.getValue() && cell.getValue().toLocaleString()
													) : cell.column.columnDef.type === "number" ? (
														cell.getValue() && cell.getValue().toLocaleString()
													) : (
														// cell.render("Cell") || ""
														// cell.getValue()
														flexRender(
														 cell.column.columnDef.cell,
														 cell.getContext()
														)
													)}
												</span>
											 )}

											</td>
										);
									})}
								 </tr>
								);
							})}
						</tbody>
					 ) : (
						<tbody>
							<tr>
								<td style={{ fontSize: "15px", height: "80px", display: "flex", justifyContent: "center", alignItems: "center"}} className="back-lightgray">
								 조회된 데이터가 없습니다.
								</td>
							</tr>
						</tbody>
					 )}
					</table>
				</div>
				{isPageNation && (
					<div className="me-pagenation">
					 <button onClick={() => table.firstPage()} disabled={!table.getCanPreviousPage()}>
						{" "}
						처음{" "}
					 </button>
					 <button onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()}>
						{" "}
						이전{" "}
					 </button>
					 <span>
						{" "}
						페이지 {table.PaginationState.pageIndex + 1} / {table.getPageCount()}{" "}
					 </span>
					 <button onClick={() => table.nextPage()} disabled={!table.getCanNextPage()}>
						{" "}
						다음{" "}
					 </button>
					 <button onClick={() => table.lastPage()} disabled={!table.getCanNextPage()}>
						{" "}
						마지막{" "}
					 </button>
					</div>
				)}
				{pagingInfo && pagingInfo.totalCnt > 0 && (
					<DataTablePaging cntPerPage={pagingInfo.cntPerPage} pageNo={pagingInfo.pageNo} totalCnt={pagingInfo.totalCnt} searchFnc={pagingInfo.searchFnc} searchCond={pagingInfo.searchCond} />
				)}

			</div>
		 )}
		</>
	);
};

export default ReactDataTableDisplay;